module.exports = __webpack_public_path__ + "img/recruit0.2a22e8f1.png";